import React from "react";
import { ArrowDown, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LArtDeBatirEtDeRenover() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="lart-de-bâtir-et-de-rénover" ref={sectionRef} className="relative flex flex-col lg:flex-row min-h-[90vh] bg-background overflow-hidden border-b border-border">
      {}
      <div className="w-full lg:w-[60%] flex flex-col justify-center px-6 py-12 lg:px-16 xl:px-24 relative z-10 !bg-[url(https://nsdb.10web.cloud/wp-content/uploads/2026/03/a-25.jpg)]">
        {}
        <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} />

        <div className="absolute inset-0 bg-background/70 pointer-events-none z-0" />

        <div className={`relative z-10 transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Badge variant="outline" className="mb-6 font-mono text-primary border-primary/20 bg-muted px-3 py-1 text-sm tracking-wider uppercase rounded-none">
            Depuis 2008
          </Badge>

          <h1 className="font-sans text-5xl lg:text-7xl xl:text-8xl font-bold tracking-tighter text-foreground mb-6 leading-[0.95]">Votre Projet,<br /><span className="text-primary" data-ast-id="f:/src/pages/Home/sections/LArtDeBatirEtDeRenover.tsx|sig:p8yc2l" data-ast-start="1742" data-ast-end="1788">Notre Expertise</span></h1>

          <p className="text-lg lg:text-xl text-muted-foreground max-w-xl mb-10 leading-relaxed font-light border-l-2 border-primary/30 pl-6">De la conception à la réalisation, nous accompagnons professionnels et particuliers, via 3 pôles d'expertise, à chaque étape de leur projet en Auvergne-Rhône-Alpes.</p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" className="rounded-none text-base px-8 h-14 shadow-md bg-primary text-primary-foreground hover:bg-primary/90">
              <Link to="#nos-poles-dexpertise">
                Nos Services
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="ghost" size="lg" className="rounded-none text-base px-8 h-14 border border-border hover:bg-accent hover:text-accent-foreground transition-colors">
              <Link to="#vision-fondations">Notre Histoire</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-[40%] relative min-h-[50vh] lg:min-h-auto overflow-hidden bg-muted">
        <div className={`absolute inset-0 transition-transform duration-[2000ms] ease-out ${isVisible ? "scale-105" : "scale-110"}`}>
          <img src="https://nsdb.10web.cloud/wp-content/uploads/2026/03/Homey-Vibes.jpg" alt="Architecture moderne à Lyon" className="w-full h-full object-cover object-center" />
          {}
          <div className="absolute inset-0 bg-foreground/5 mix-blend-multiply" />
        </div>
        
        {}
        <div className="absolute bottom-0 left-0 w-24 h-24 border-l border-b border-background/50 z-20 hidden lg:block" />
        <div className="absolute top-0 right-0 w-24 h-24 border-r border-t border-background/50 z-20 hidden lg:block" />
      </div>
    </section>;
}